const config = {
    token: '8c66a1b2-c3c1-4d07-a406-bbc7f2283269',
    storageUrl: 'https://firebasestorage.googleapis.com/v0/b/zametix-9a1ec.appspot.com/o/img%2F'
}

export default config;



// WEBPACK FOOTER //
// ./src/config.js